import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { getCode } from 'app/utils/method';
import { DocumentDetailClassAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Type Line Cell Renderer
 *
 *
 * @example
 * ```typescript
 * {
 *   field: 'type',
 *   headerName: 'Tipo',
 *   cellRenderer: TypeLineCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
    selector: 'app-material-cell-renderer',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="leading-tight">
        <b class="f-10" *ngIf="typeCode">
        {{ typeCode }} <br>
        </b>
        <span>{{ params.data?.documentDetailType?.name }}</span>
    </div>
  `,
})
export class TypeLineCellRendererComponent implements CellRenderer<DocumentDetailClassAttributes> {
    @Input() params!: CellRendererParams<DocumentDetailClassAttributes>;

    get typeCode(): string | null {
        return getCode(this.params.data?.documentDetailType);
    }
}
